import React, { Component, Fragment } from "react";
import Index from "../../Components/ProducaoSTI/Realizado/Relatorio1/Index";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Navbar from "../../Components/ProducaoSTI/Realizado/UI/Navbar";
import MenuRelatorioSTI from "./menuRelatorioSTI";
import NomeUnidade from "../../Components/UI/NomeUnidade";

export default class PageRelatorio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <Index />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}